import { inject, Injectable } from '@angular/core';
import { SocialLogin } from '@capgo/capacitor-social-login';
import { FuseConfigService } from '@fuse/services/config';

@Injectable({ providedIn: 'root' })
export class GoogleAuthService {
  private initialized = false;
  private _fuseConfigService = inject(FuseConfigService);

  /**
   * Initialize the SocialLogin plugin for Google.
   * Must be called once at app startup or before first login attempt.
   */
  async initialize(): Promise<void> {
    if (this.initialized) return;

    await SocialLogin.initialize({
      google: {
        webClientId: '989833920907-pd4c9nghnievuel0qtc88mno0qjlmi8t.apps.googleusercontent.com',
        mode: 'online',
        redirectUrl: this._fuseConfigService.global.settings["domainURL"] + "google/auth-web",
      }
    });

    this.initialized = true;
  }

  /**
   * Perform Google login via popup flow.
   * Returns the idToken and profile info on success.
   */
  async login(): Promise<{ idToken: string; profile: any }> {
    await this.initialize();

    const res = await SocialLogin.login({
      provider: 'google',
      options: {
        scopes: ['email', 'profile'],
      }
    });

    if (res.result.responseType === 'online') {
      return {
        idToken: res.result.idToken,
        profile: res.result.profile,
      };
    }

    throw new Error('Unexpected response type from Google login');
  }

  /**
   * Check if user is currently logged in with Google.
   */
  async isLoggedIn(): Promise<boolean> {
    const result = await SocialLogin.isLoggedIn({ provider: 'google' });
    return result.isLoggedIn;
  }

  /**
   * Logout from Google.
   */
  async logout(): Promise<void> {
    await SocialLogin.logout({ provider: 'google' });
  }
}
